import { all } from 'redux-saga/effects';
import { accountWatcherSaga } from './accountSaga';
import { pagesWatcherSaga } from './pagesSaga';
import { siteWatcherSaga } from './siteSaga';

export default function* () {
  yield all([accountWatcherSaga(), pagesWatcherSaga(), siteWatcherSaga()]);
}
